var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-subheader',[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('div',{staticClass:"px-3"},[(_vm.isSpecified)?_vm._t("default",[_vm._v(_vm._s(_vm.fieldValue))],{"value":_vm.value}):_c('span',[_vm._v(_vm._s(_vm.notSpecifiedText))])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3f17bb6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/jobs_overview/job_details_view/job_info/JobDetailsField.vue
// module id = 414
// module chunks = 1